/**
 * Routes where the navigation bar offers no search field, matched on the exact
 * path.
 *
 * @const GLOBAL_SEARCH_HIDDEN_ROUTES
 * @since 1.0.0
 */
export const GLOBAL_SEARCH_HIDDEN_ROUTES = [
    // The results screen carries its own field, above its tabs, and that one is
    // the only field below md where the bar's is hidden.
    'search',
    'unauthorized'
];
/**
 * Whole subtrees where it offers none, matched on the path prefix.
 *
 * @const GLOBAL_SEARCH_HIDDEN_TREES
 * @since 1.0.0
 */
export const GLOBAL_SEARCH_HIDDEN_TREES = [
    // The hub administers accounts other than the current one, so a field that
    // searches the current account would be misleading there. One prefix covers
    // all eight hub screens.
    'hub.overview'
];
/**
 * Whether the field is hidden on a path.
 *
 * `resolve` is `useRoute().get`, which returns '' outside the Routing
 * provider — so an empty resolution is never treated as a match. That alone is
 * not enough to keep the field out of a public layout, which is why
 * GlobalSearchProvider gates by context as well.
 *
 * @function isGlobalSearchHidden
 * @since 1.0.0
 */
export function isGlobalSearchHidden(pathname, resolve) {
    for (const name of GLOBAL_SEARCH_HIDDEN_TREES) {
        const prefix = resolve(name);
        if (prefix !== '' && pathname.indexOf(prefix) === 0) {
            return true;
        }
    }
    for (const name of GLOBAL_SEARCH_HIDDEN_ROUTES) {
        const path = resolve(name);
        // location.pathname excludes the query string, so equality is enough
        // despite ?q=.
        if (path !== '' && pathname === path) {
            return true;
        }
    }
    return false;
}
